import { i18n } from '@plugins/vuetify';
import { SERVICE_MANAGEMENT_ACCESS_NAME, SERVICE_MANAGEMENT_SERVICE_NAME, ACCOUNT_MANAGEMENT_NAME, USER_MANAGEMENT_NAME } from '@constants/navigation';


export const getCurrentModule = () => {
	const route = window.location.pathname;
	if (route.startsWith('/userMgmt')) {
		return USER_MANAGEMENT_NAME;
	} else if (route.startsWith('/serviceMgmt/lookUp')) {
		return SERVICE_MANAGEMENT_ACCESS_NAME;
	} else if (route.startsWith('/serviceMgmt/services')) {
		return SERVICE_MANAGEMENT_SERVICE_NAME;
	} else if (route.startsWith('/accMgmt')) {
		return ACCOUNT_MANAGEMENT_NAME;
	}
	return null;
};
